"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Reports/components/Cards.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);









const Card = ({ label, value, note }) => {
  const labelId = _react.useId.call(void 0, )
  return (
    _react2.default.createElement('div', { className: "settings--org-reports--card", role: "group", 'aria-labelledby': labelId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
      , _react2.default.createElement('div', { id: labelId, className: "settings--org-reports--card-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}},  label )
      , _react2.default.createElement('div', { className: "settings--org-reports--card-value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}},  value )
      , _react2.default.createElement('div', { className: "settings--org-reports--card-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}},  note )
    )
  )
}

const n = (v) => v.toLocaleString('en-US')

// "2.5%": one decimal under 10%, whole above.
const share = (part, whole) => {
  const p = part / whole * 100
  return `${p < 10 ? Math.round(p * 10) / 10 : Math.round(p)}%`
}









const Cards = ({ cards, totalTexts, isTeamPicked, onShowFailed }) => (
  _react2.default.createElement('div', { className: "settings--org-reports--cards", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
    , _react2.default.createElement(Card, {
      label: "Delivered",
      value: cards.DeliveredPercent === null ? 'No results yet' : `${cards.DeliveredPercent}%`,
      note: cards.Final > 0 ? `${n(cards.Delivered)} of ${n(cards.Final)} with a final status` : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
    )
    , _react2.default.createElement(Card, {
      label: "Failed",
      value: n(cards.Failed),
      note: totalTexts > 0 && (
        _react2.default.createElement(_react2.default.Fragment, null
          ,  share(cards.Failed, totalTexts) , " of "  ,  n(totalTexts) , " texts"
          ,  cards.Failed > 0 && (
            _react2.default.createElement(_react2.default.Fragment, null
              , ' · '
              , _react2.default.createElement('button', { type: "button", className: "settings--org-reports--link", onClick: onShowFailed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "Show")
            )
          )
        )
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
    )
    /* Opt-outs aren't recorded per number, so they always count every team. */
    , _react2.default.createElement(Card, {
      label: "Opted out" ,
      value: n(cards.OptedOut),
      note: isTeamPicked ? 'All teams' : 'Patients who opted out of texts', __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
    )
    , _react2.default.createElement(Card, { label: "Patients messaged" , value: n(cards.PatientsMessaged), note: "Patients sent at least one text"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} )
  )
)

exports. default = Cards
